const joinName = names => names.filter(n => n).join(' ');

export default joinName;
